const MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

module.exports = {
  
  date: (date, prefomattedDate = false, hideYear = false) => {
    const day = date.getDate();
    const monthNum = date.getMonth();
    const month = MONTH_NAMES[monthNum];
    const year = date.getFullYear();
    const hours = date.getHours();
    let minutes = date.getMinutes();
  
    if (minutes < 10) {
      minutes = `0${ minutes }`;
    }
  
    if (prefomattedDate) {
      return `${ prefomattedDate } at ${ hours }:${ minutes }`;
    }
  
    if (hideYear) {
      return `${ month } ${ day }`;
    }
  
    return `${ monthNum + 1 }/${ day }/${ year }`;
  },
  
  
  time: (timestamp) => {
    let date = new Date(timestamp);
    
    let period = "am";
    let hour = date.getHours();
    if (hour > 12) {
      period = "pm";
      hour-=12;
    }
    let minute = date.getMinutes();
    if (minute < 10) {
      minute = `0${ minute }`;
    }
    
    return `${hour}:${minute}${period}`;
  }
  
}